export default function getResource(label, vars = []) {
    const resources = {
        phone: 'Phone',
        phoneNumber: 'Phone Number',
        edit: 'Edit',
        remove: 'Remove',
        confirmPhoneLabel: 'Confirm Phone Number*',
        cancel: 'Cancel',
        update: 'Save',
        and: ' and ',
        emptyPhoneMessage: 'Please fill out this field.',
        invalidConfirmationMessage: 'Please ensure the phone numbers entered match',
        invalidPhoneMessage: 'Enter a valid phone number',
        phoneNumberRejected: 'Invalid phone type. Please check your entry or use a valid entry.',
        marketingCheckbox: 'Sign me up for texts from Sephora',
        disclosure: 'Sephora Text Alerts Disclosure: ',
        by: 'By ',
        entering: 'entering your phone number, ',
        checkingThe: 'checking the ',
        textStopAddress: ' Sephora: 160 Bloor St E Suite 1100, Toronto, ON M4W 0A2, Canada. 1-877-737-4672.',
        clicking: `clicking the “${vars[0]}” button and confirming sign-up, you consent and agree to receive recurring autodialed marketing texts, including abandoned cart reminders, and confirm that you have read and agree to the`,
        textTerm: ' TEXT TERMS.',
        message: ' Message frequency varies. Consent is not a condition of purchase. Message & data rates may apply. See our ',
        privacy: 'PRIVACY POLICY',
        noticeOf: 'NOTICE OF FINANCIAL INCENTIVE',
        textStop: ' Text STOP to cancel at any time. HELP for help.',
        InFoDescription: 'If your previous number was subscribed to Sephora text alerts, it will be unsubscribed. Subscribe with your new number to avoid missing out.',
        InfoModaltitle: 'Unsubscribe Notice',
        GotIt: 'Got It',
        sephoraTexts: 'Sephora Texts',
        notSubscribed: 'You are not subscribed',
        subscribed: 'Subscribed',
        subscribe: 'Subscribe',
        subscribeContinue: 'Continue',
        unsubscribe: 'Unsubscribe',
        subscribeInfoTitle: 'Subscribe to Sephora Texts',
        unsubscribeInfoTitle: 'Unsubscribe from Sephora Texts',
        unsubscribeInfoDescription: 'Are you sure you want to unsubscribe from Sephora Texts at this number?',
        unsubscribeInfoDescription2: 'You may miss out on exclusive deals and drops only for Beauty Insiders.',
        add: 'Add',
        noPhone: 'No phone number saved',
        phoneVerificationLabel: 'Phone Verification',
        phoneVerificationEnabled: 'You are enabled',
        phoneVerificationNotEnabled: 'Your phone is not enabled',
        phoneVerificationInfoTitle: 'Help us keep your account secure',
        phoneVerificationInfoMessage: 'This helps us ensure that only you have access to your account and protects your information from unauthorized access.'
    };
    return resources[label];
}
